import gql from 'graphql-tag';
import FieldsBuilding from "graphql/fields/FieldsBuilding";
import FieldsTimeslot from "graphql/fields/FieldsTimeslot";
import HelperGraphql from 'utils/helper-graphql'

const fields = {
	'kind': 'String',
	'sub_kind': 'String',
	'timeslot_day': '[Int]',
};

export default gql(`
	query building( ${ HelperGraphql.createFields( fields ) } ) {
		buildings {
			${FieldsBuilding}
			
			floors {
				guid
			}
			
			lunch_options {
	            lunch_option {
	               guid
	            }
	        }
			
			timeslots_through( ${ HelperGraphql.createVariables( fields ) } ) {
                ${FieldsTimeslot}
            }
		}
	}
`);

